import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom"; // added
import "../assests/CSS/floatingCTA.css";

const FloatingCTA = () => {
  const [show, setShow] = useState(true);
  const [hiddenForever, setHiddenForever] = useState(false);
  const observerRef = useRef(null);
  const navigate = useNavigate(); // added

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        let footerVisible = false;
        let matchButtonVisible = false;

        entries.forEach((entry) => {
          if (entry.target.tagName.toLowerCase() === "footer") {
            footerVisible = entry.isIntersecting;
          }
          if (entry.target.classList.contains("match-button-container")) {
            matchButtonVisible = entry.isIntersecting;
          }
        });

        if (footerVisible) {
          setHiddenForever(true);
          setShow(false);
          return;
        }

        if (!footerVisible && hiddenForever) {
          setHiddenForever(false);
        }

        if (matchButtonVisible) {
          setShow(false);
        } else if (!hiddenForever) {
          setShow(true);
        }
      },
      { threshold: 0.1 }
    );

    const footer = document.querySelector("footer");
    const matchButton = document.querySelector(".match-button-container");

    if (footer) observerRef.current.observe(footer);
    if (matchButton) observerRef.current.observe(matchButton);

    return () => {
      observerRef.current?.disconnect();
    };
  }, [hiddenForever]);

  const handleClick = () => {
    
    navigate("/#inquiry-form");
  };

  if (!show) return null;

  return (
    <div className="floating-cta">
      <span className="cta-text">
        Would you like us to find you a partner who can support you with your
        needs?
      </span>
      <button className="cta-button" onClick={handleClick}>
        Submit Request
      </button>
    </div>
  );
};

export default FloatingCTA;
